import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Lender } from '@models/lender';

@Component({
	selector: 'app-closer-sync-missing-documents',
	templateUrl: './closer-sync-missing-documents.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncMissingDocumentsComponent {
	@Input() lender: Lender;
}
